module.exports = __webpack_public_path__ + "static/img/DM.31ed5fa4.svg";